var map = {
	"./certificate.svg": 497,
	"./rate.svg": 498,
	"./refund.svg": 499,
	"./report.svg": 500,
	"./reschedule.svg": 501,
	"./transfer.svg": 502
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 496;


//////////////////
// WEBPACK FOOTER
// ./src/public/images/ssp2 ^\.\/.*\.svg$
// module id = 496
// module chunks = 0